import { IMenuItem } from '../interfaces/layout.interface';
import { PermissionKey } from '../../shared/enum/permission-key.enum';

// Each story adds its own page here.
export const SIDEBAR_MENU: IMenuItem[] = [
    {
        items: [
            {
                label: 'Home',
                icon: 'pi pi-home',
                routerLink: ['/'],
                testId: 'sidebar-home-link',
            },
            {
                label: 'Playbooks',
                icon: 'pi pi-sitemap',
                routerLink: ['/playbooks'],
                testId: 'sidebar-playbooks-link',
                permission: PermissionKey.PLAYBOOKS,
            },
            {
                label: 'Runs',
                icon: 'pi pi-history',
                routerLink: ['/runs'],
                testId: 'sidebar-runs-link',
                permission: PermissionKey.RUNS,
            },
            {
                label: 'Settings',
                icon: 'pi pi-cog',
                testId: 'sidebar-settings',
                items: [
                    {
                        label: 'AI keys',
                        icon: 'pi pi-key',
                        routerLink: ['/settings/ai-keys'],
                        testId: 'sidebar-ai-keys-link',
                        permission: PermissionKey.SETTINGS_AI_KEYS,
                    },
                    {
                        label: 'Test contacts',
                        icon: 'pi pi-users',
                        routerLink: ['/settings/test-contacts'],
                        testId: 'sidebar-test-contacts-link',
                        permission: PermissionKey.CONTACTS,
                    },
                ],
            },
        ],
    },
];
